import React from 'react';
import AnimateHeight from 'react-animate-height';

import { executeCallback } from 'core/utils/global-utils';

interface IProps {
	isOpen: boolean;

	forceFlexDisplay?: boolean;
	className?: string;
	contentClassName?: string;
	duration?: number;

	onOpenStart?: () => void;
	onCloseStart?: () => void;
	onOpenEnd?: () => void;
	onCloseEnd?: () => void;

	ariaAttributes?: { [key: string]: string | number };

	children: React.ReactNode;
}

const Collapse = ({
	isOpen,

	forceFlexDisplay,
	className,
	contentClassName,
	duration = 300,

	onOpenStart,
	onCloseStart,
	onOpenEnd,
	onCloseEnd,

	ariaAttributes,

	children,
}: IProps) => (
	<AnimateHeight
		className={className}
		contentClassName={contentClassName}
		duration={duration}
		height={isOpen ? 'auto' : 0}
		aria-expanded={ariaAttributes?.ariaExpanded ? isOpen : undefined}
		onAnimationStart={() => {
			if (isOpen) {
				executeCallback(onOpenStart);
			} else {
				executeCallback(onCloseStart);
			}
		}}
		onAnimationEnd={() => {
			if (isOpen) {
				executeCallback(onOpenEnd);
			} else {
				executeCallback(onCloseEnd);
			}
		}}
		style={forceFlexDisplay ? { display: 'flex' } : {}}
	>
		{children}
	</AnimateHeight>
);

export default Collapse;
